import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { SidebarCategoryDropdownItem } from './SidebarCategoryTypes';

interface Props {
    dropdownItem: SidebarCategoryDropdownItem;
}

const LeftSidebarCategoryDropdownItem = ({ dropdownItem }: Props) => {
    const location = useLocation();
    const [isSelected, setIsSelected] = useState(false);

    useEffect(() => {
        const hasActiveItem = dropdownItem.items?.some((item) => location.pathname.startsWith(item.path));
        if (hasActiveItem) {
            setIsSelected(true);
        }
    }, [dropdownItem.items, location.pathname]);

    const handleClick = () => {
        setIsSelected(!isSelected);
    };

    return (
        <li className={`sidebar-item ${isSelected ? 'selected' : ''}`}>
            <a
                className={`sidebar-link waves-effect waves-dark ${dropdownItem.items ? 'has-arrow' : ''} ${
                    isSelected ? 'active' : ''
                }`}
                aria-expanded={isSelected ? 'true' : 'false'}
                onClick={handleClick}
            >
                <i className={`mdi ${dropdownItem.icon}`} />
                <span className="hide-menu">{dropdownItem.name}</span>
            </a>
            {dropdownItem.items && (
                <ul className={`collapse first-level ${isSelected ? 'in' : ''}`}>
                    {dropdownItem.items.map((item) => (
                        <li
                            key={item.name}
                            className={`sidebar-item ${location.pathname.startsWith(item.path) ? 'active' : ''}`}
                            onClick={item.clickCallback}
                        >
                            <Link className="sidebar-link" to={item.path}>
                                <i className={`mdi ${item.icon}`} />
                                <span className="hide-menu">{item.name}</span>
                            </Link>
                        </li>
                    ))}
                </ul>
            )}
        </li>
    );
};

export default LeftSidebarCategoryDropdownItem;
